import React, { useEffect } from "react";
// import firstSectionImg2 from "../assests/firstSectionImg2.svg";
import aboutMeImage from "../assests/aboutMeImage.png";
import starImage from "../assests/starImage.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import outsourcingImg from '../assests/secondSectionBgImg.jpg'
export default function Outsourcing() {
  const handleGetInTouch = () => {
    const getInTouchSection = document.getElementById("about_me");
    if (getInTouchSection) {
      const topOffset = getInTouchSection.offsetTop - 90;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      delay: 100,
    });
  }, []);
  return (
    <div className="outsourcingMain" id="about_me">
      <div className="firstSection">
        <div className="firstSectionContainer pt-11">
          <div data-aos="fade-down-right" className="firstSectionChild2">
            <img
              className="zoom-effect"
              style={{ width: "100%" }}
              src={aboutMeImage}
              alt=""
            />
          </div>
          <div data-aos="fade-down-left" className="firstSectionChild1">
            <h1 className="firstSectionChild1Head">
            EXPERIENCE AND JOURNEY
            </h1>
            <p className="text-white text-xl mb-3">Mr. Zulqarnain Mahmood</p>
            <p className="firstSectionChild1Para">
              In 1996, I started in grassroot level in real estate business. I've personally dealt with over 14,000+ properties till now.</p>
            {/* <button
              onClick={handleGetInTouch}
              className="firstSectionChild1Button"
            >
              Learn more
            </button> */}
          </div>

          {/* <div className="starImageContainer">
            <img style={{ width: "100%" }} src={starImage} alt="" />
          </div> */}
        </div>

        {/* <div data-aos="fade-up">
          <div className="firstSectionContainerTwo">
            <h1 className="firstSectionContainerTwoHead">
              HR Outsourcing & Manpower Supply Solutions Diverse Capabilities
            </h1>
            <p className="firstSectionContainerTwoPara  py-5 md:py-8 lg:py-3">
              With AM Global you can outsource your entire HR function or any
              specific HR services that you may need. We will work with you to
              develop a customized solution that meets your specific business
              needs with ease.
            </p>
          </div>
          <div className="outsourchingButtonContainer">
            <div className="outsourchingButton1">
              Efficient & Cost-Effective
            </div>
            <div className="outsourchingButton">
              Comprehensive Suite of Services
            </div>
            <div className="outsourchingButton">
              Experienced & Professional Team
            </div>
            <div className="outsourchingButton">
              Streamlined & Customized Solutions
            </div>
          </div>
        </div> */}
      </div>
      {/* <div className="">
        <div className="">
          <div className="secondSection">
            <img src={outsourcingImg} alt="" />
          </div>
        </div>
      </div> */}
    </div>
  );
}
